var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('sidebar',{attrs:{"slot":"sidebar"},slot:"sidebar"}),_vm._v(" "),_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Knowledge Check Reporting")]),_vm._v(" "),_c('b-tabs',{attrs:{"card":"","no-fade":""}},[_c('b-tab',{attrs:{"title":"Completed","active":""}},[_c('completed')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e1a172","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/admin/knowledge-checks/reports/index.vue
// module id = null
// module chunks = 